<template>
  <div>
    <van-list
      v-model="loading"
      :finished="finished"
      :error="error"
      :offset="0"
      :immediate-check="false"
      :finished-text="articleList.length > 0 ? '加载完毕' : ''"
      error-text="请求失败，点击重新加载"
      @load="onLoad"
    >
      <div class="lv-list" v-if="loading || articleList.length > 0">
        <!-- 论文item -->
        <div v-if="listType === '0'">
          <LvItem
            class="lv-list-item"
            v-for="(item, index) in articleList"
            :key="index"
            :type="item.type"
            :title="item.title"
            :artSummary="item.artSummary"
            :author="item.firstAuthor"
            :otherAuthor="
              item.articleAuthorList && item.articleAuthorList.length > 1
                ? ',...'
                : ''
            "
            :periodicalName="item.periodical"
            :periodicalTime="item.type === 1 ? item.mettingTime : item.timeStr"
            @click.native="toDetail(item.articleType, item.articleId)"
          />
        </div>
        <!-- 专著item -->
        <div v-if="listType === '2'">
          <ZzItem
            v-for="(item, index) in articleList"
            :key="index"
            class="lv-list-item"
            :title="item.monographName"
            :cover="item.cover"
            :artSummary="item.artSummary"
            :author="
              item.articleAuthors.length > 1
                ? `${item.articleAuthors[0].authorName}等`
                : item.articleAuthors[0]
                ? item.articleAuthors[0].authorName
                : ''
            "
            @click.native="toDetail(2, item.articleId)"
          />
        </div>
        <!-- 资讯item -->
        <div v-if="listType === '5'">
          <ZxItem
            class="lv-list-item"
            v-for="(item, index) in articleList"
            :key="index"
            :title="item.title"
            :img="item.cover"
            :creatTime="item.originalPublishTime | dateFormat"
            :number="item.readPv"
            :author="item.authorList[0]"
            @click.native="toDetail(5, item.articleId)"
          />
        </div>
        <!-- 会议item -->
        <div v-if="listType === '8'">
          <XshyItem
            class="hy-list-item"
            v-for="(item, index) in articleList"
            :key="index"
            :title="item.title"
            :cover="item.cover"
            :beginTime="
              item.beginTime.slice(0, 10).replace(RegExp('-', 'g'), '.')
            "
            :address="item.province ? item.province + '-' + item.city : ''"
            @click.native="toDetail(8, item.id, item.goodsId, item.open)"
          />
        </div>
        <!-- 课程itme -->
        <div class="px-list-box" v-if="listType === '9'">
          <PxItem
            class="px-list-item"
            v-for="(item, index) in articleList"
            :key="index"
            :cover="item.cover"
            :title="item.title"
            :price="item.curriculumPrice"
            :saleType="item.saleType"
            :author="item.publisher"
            :number="item.enrollment"
            @click.native="toDetail(9, item.id, item.goodsId)"
          />
        </div>
        <!-- 图书item -->
        <div class="ts-list-box" v-if="listType === '11'">
          <TsItem
            class="ts-item"
            v-for="(item, index) in articleList"
            :key="index"
            :title="item.goodsName"
            :cover="item.albumPics"
            :price="item.goodsPrice"
            @click.native="toDetail(11, item.id)"
          />
        </div>
        <!-- 行业报告item -->
        <div class="bg-list-box" v-if="listType === '12'">
          <BgItem
            class="bg-item"
            v-for="item in articleList"
            :key="item.id"
            :title="item.goodsName"
            :cover="item.albumPics"
            :price="item.goodsPrice"
            :industryOne="item.goodsAttributeVoList.industryLevelOne.fieldValue"
            :industryTwo="item.goodsAttributeVoList.industryLevelTwo.fieldValue"
            @click.native="toDetail(12, item.id)"
          />
        </div>
      </div>
      <noneList :noneType="listType | typeFilter" v-else />
    </van-list>
  </div>
</template>

<script>
import LvItem from "@/views/mobileView/components/listItem/lvItem.vue";
import ZzItem from "@/views/mobileView/components/listItem/zzItem.vue";
import ZxItem from "@/views/mobileView/components/listItem/zxItem.vue";
import XshyItem from "@/views/mobileView/components/listItem/xshyItem.vue";
import PxItem from "@/views/mobileView/components/listItem/pxItem.vue";
import TsItem from "@/views/mobileView/components/listItem/tsItem.vue";
import BgItem from "@/views/mobileView/components/listItem/bgItem.vue";
import noneList from "@/views/mobileView/components/noneList.vue";
export default {
  components: {
    LvItem,
    ZxItem,
    XshyItem,
    ZzItem,
    PxItem,
    TsItem,
    BgItem,
    noneList,
  },
  props: {
    listType: {
      // 文章类型
      type: String,
    },
    argumentObj: {
      // 文章类型参数
      type: Object,
      require: true,
    },
    listRequest: {
      // 获取文章调取接口方法
      type: Function,
      require: true,
    },
  },
  data() {
    return {
      articleList: [], // 文章List
      params: {
        pageNo: 1,
        pageSize: 20,
      },
      loading: false,
      finished: false,
      error: false,
    };
  },
  filters: {
    typeFilter(type) {
      switch (type) {
        case "0":
          return "lvList";
        case "2":
          return "zzList";
        case "5":
          return "zxList";
        case "8":
          return "hyList";
        case "9":
          return "pxList";
        case "11":
          return "tsList";
        case "12":
          return "bgList";
      }
    },
    // 时间格式化
    dateFormat(o) {
      if (o) {
        const dt = new Date(o);
        const m = (dt.getMonth() + 1 + "").padStart(2, "0");
        const d = (dt.getDate() + "").padStart(2, "0");
        return `${m}-${d}`;
      } else {
        return "";
      }
    },
  },
  created() {
    this.getInformation();
  },
  methods: {
    // 触底加载
    onLoad() {
      console.log(1);

      this.params.pageNo += 1;
      this.getInformation();
    },
    // 调取父组件获取文章列表接口方法
    async getInformation() {
      this.loading = true;
      let res = await this.listRequest({
        ...this.params,
        ...this.argumentObj,
      });
      if (res.isSuccess) {
        if (this.params.pageNo > 1) {
          this.articleList.push(...res.list);
        } else {
          this.articleList = res.list;
        }
        this.finished = res.list.length < 20;
      } else {
        this.error = true;
      }
      this.loading = false;
    },
    // 跳转文章详情页
    toDetail(type, id, goodsId, open) {
      let out = this.$route.query.out;
      switch (type) {
        case 0:
          this.$router.push({
            path: "thesisDetail",
            query: { type, id, out },
          });
          break;
        case 2:
          this.$router.push({
            path: "concentrationDetails",
            query: { type, id, out },
          });
          break;
        case 5:
          this.$router.push({
            path: "msgDetails",
            query: { type, id, out },
          });
          break;
        case 8:
          window.open(
            this.$global.meetingH5Url +
              `pagesModule/meetingDetails/index?type=8&id=${id || goodsId}${
                open ? "&open=" + open : ""
              }${out ? "&out=" + out : ""}`,
            "_self"
          );
          break;
        case 9:
          this.$router.push({
            path: "courseDetails",
            query: { type, id, goodsId, out },
          });
          break;
        case 11:
          this.$router.push({
            path: "bookDetails",
            query: { id, out },
          });
          break;
        case 12:
          this.$router.push({
            path: "/detail/report",
            query: { id, out },
          });
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.screen-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .date-cell {
    padding: 0;
    width: unset;
    &::v-deep .van-cell__value {
      flex: none;
      color: #999;
    }
    &::after {
      display: none;
    }
  }
  .active-date-cell {
    &::v-deep .van-cell__value {
      flex: none;
      color: #333;
    }
  }
  .choiceness-btn {
    flex: none;
    padding: 5px 12px;
    color: #333;
    background-color: #f7f8fa;
    border-radius: 15px;
  }
  .choiceness-active-btn {
    background-color: #4a79f1;
    color: #fff;
  }
}
.date-popup-top {
  display: flex;
  justify-content: space-between;
  padding: 17px 24px;
  border-bottom: 1px solid #ededed;
  font-size: 16px;
  color: #333333;
}
.date-popup-select {
  display: flex;
  position: relative;
  width: 100%;
  height: 400px;
  overflow-y: auto;
  &::v-deep .van-index-bar__sidebar {
    top: unset;
    left: 0;
    width: 90px;
    height: 400px;
    overflow-y: auto;
    background-color: #f5f6f6;
    transform: none;
    .van-index-bar__index {
      padding: 12px 27px;
      font-size: 15px;
    }
    .van-index-bar__index--active {
      background-color: #fff;
      color: #4a79f1;
    }
  }
  .date-popup-select-content {
    padding-left: 110px;
    width: 100%;
    .date-popup-select-point {
      height: unset !important;
      &::v-deep .van-index-anchor {
        position: relative;
        left: 0 !important;
        transform: none !important;
        padding: 10px 0 15px;
        font-size: 15px;
        color: #333333;
        line-height: normal;
        &::after {
          display: none;
        }
      }
    }
    .date-popup-select-box {
      .date-popup-select-item {
        display: inline-block;
        margin-right: 10px;
        margin-bottom: 10px;
        width: 75px;
        height: 35px;
        line-height: 35px;
        text-align: center;
        background-color: #f5f5f5;
        border-radius: 18px;
        font-size: 13px;
        color: #333333;
        &:nth-child(3n) {
          margin-right: 0;
        }
      }
      .date-popup-select-item-active {
        background-color: #4a79f1;
        color: #fff;
      }
    }
  }
}
.lv-list {
  .lv-list-item {
    border-bottom: 1px solid #ededed;
  }

  .hy-list-item {
    margin-bottom: 13px;
    padding-bottom: 15px;
    width: 100%;
    border-radius: 8px;
    background-color: #fff;
    border: 1px solid #ededed;
    overflow: hidden;
  }

  .ts-list-box {
    width: 100%;
    column-count: 2;
    column-gap: 1em;

    .ts-item {
      border: 1px solid #f1f1f1;
      box-sizing: border-box;
      -webkit-column-break-inside: avoid;
      break-inside: avoid;
      //   max-height: 200px;
      margin-bottom: 20px;
      width: 155px;
    }
  }

  .px-list-box {
    .px-list-item {
      display: inline-block;
      margin-top: 12px;
      margin-right: 10px;
      width: 150px;
      border: 1px solid #f1f1f1;
      border-radius: 6px;
      background-color: #fff;
      overflow: hidden;

      &:nth-child(2n) {
        margin-right: 0;
      }
    }
  }

  .bg-list-box {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .bg-item {
      margin-bottom: 12px;
      width: 156px;
      border-radius: 6px;
      border: 1px solid #f1f1f1;
      overflow: hidden;
    }
  }
}
</style>
